import React, { FC, useState } from 'react';
import { Select, SelectOption, TranslatedString } from '../../../components/blocks/localization';

// The line items table's own select, kept separate from the shared SearchableSelect because it needs
// option groups, matching on a hidden value, an error state and a fixed popover height that adding to
// the shared one would have forced on every other page's dropdown.

export type PoReviewItemOption = {
    value: string;
    label: TranslatedString;
    searchText?: TranslatedString;
};

export type PoReviewItemSelectProps = {
    value?: string;
    onChange(value: string): void;
    options: PoReviewItemOption[];
    placeholder: TranslatedString;
    width: number;
    popoverMaxHeight?: number;
    error?: boolean;
    dataTestId: string;
};

const PoReviewItemSelect: FC<PoReviewItemSelectProps> = ({
    value,
    onChange,
    options,
    placeholder,
    width,
    popoverMaxHeight,
    error,
    dataTestId,
}) => {
    const [query, setQuery] = useState('');
    const matches = (option: PoReviewItemOption) =>
        (option.searchText ?? option.label).toLowerCase().includes(query.toLowerCase());
    const visibleOptions = options.filter(matches);
    return (
        <Select
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            searchQuery={query}
            onSearch={setQuery}
            width={width}
            popoverMaxHeight={popoverMaxHeight}
            error={error}
            aria-invalid={error ? true : undefined}
            data-testid={dataTestId}
        >
            {visibleOptions.map((option) => (
                <SelectOption key={option.value} value={option.value} label={option.label} />
            ))}
        </Select>
    );
};

export { PoReviewItemSelect };
